import { defineStore } from "pinia";
import { Contact, Guidance, JackBurtonApi } from "@/services/api/sdk";
import { ApiConfiguration } from "@/services/api/api-configuration.ts";
import { computed, ref } from "vue";

export const useCallGuidanceStore = defineStore("call-guidance", () => {
    const guidance = ref<Record<string, Guidance>>({});

    function $reset() {
        guidance.value = {};
    }

    async function fetchGuidanceForCall(call: Contact): Promise<void> {
        const api = new JackBurtonApi(ApiConfiguration);
        const response = await api.getContactGuidance({
            contactId: call.id!,
        });

        response.forEach((g) => {
            addGuidance(g);
        });
    }

    async function dismiss(contactId: number, guidanceId: number): Promise<void> {
        const api = new JackBurtonApi(ApiConfiguration);
        await api.updateGuidanceStatus({
            contactId,
            guidanceId,
        });

        guidance.value[guidanceId].status = "Dismissed";
    }

    function addGuidance(g: Guidance): void {
        guidance.value[g.id!] = g;
    }

    const sortedGuidanceCards = computed<Guidance[]>(() => {
        return Object.values(guidance.value).
        filter((card) => card.status !== "Dismissed").
        sort(
            (a: Guidance, b: Guidance) => (a.dateCreated?.getTime() ?? 0) - (b.dateCreated?.getTime() ?? 0),
        );
    });

    return { $reset, guidance, fetchGuidanceForCall, dismiss, addGuidance, sortedGuidanceCards };
});
